import { graphql } from 'gatsby';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import * as React from 'react';

import PrimaryLayout from '../layouts/PrimaryLayout';
import PageIntro from '../components/layout/PageIntro';
import htmlSerializer from '../components/layout/Prismic/PrismicRender';
import PlatformSubnav from '../components/layout/LayoutFrame/PlatformSubnav';
import usePlatform from '../components/hooks/usePlatform';
import usePlatformVersion from '../components/hooks/usePlatformVersion';
import { Button, Typography } from '@nelnet/unifi-components-react';

interface IPageTemplateProps {
  data: {
    prismic: {
      allPages: {
        edges: [
          {
            node: {
              title: RichTextBlock[];
              intro: RichTextBlock[];
              page_content: RichTextBlock[];
              _meta: {
                uid: string;
                tags: string[];
              };
            };
          },
        ];
      };
    };
  };
}

const PageTemplate: React.FunctionComponent<IPageTemplateProps> = ({ data }) => {
  // Required check for no data being returned
  const doc = data.prismic.allPages.edges.slice(0, 1).pop();
  if (!doc) {
    return null;
  }

  // const { updateSubnav } = useSubnav();

  const { title, intro, page_content } = doc.node;
  const { uid, tags } = doc.node._meta;
  let slug = `/${uid}/`;
  if (tags && tags[0]) {
    if (tags[1]) {
      slug = `/${tags[0]}/${tags[1]}/${uid}/`;
    } else {
      slug = `/${tags[0]}/${uid}/`;
    }
  }
  const showPlatformSubnav = usePlatform(slug);
  const version = showPlatformSubnav ? usePlatformVersion(showPlatformSubnav) : false;
  const showStarterKit = slug.match(/(react|web)\/starter-kit/);

  const pageTitle = title && RichText.asText(title);

  return (
    <PrimaryLayout title={pageTitle || 'Prismic Preview'} path={slug}>
      {showPlatformSubnav ? <PlatformSubnav path={slug} /> : null}
      <PageIntro
        title={pageTitle || 'Prismic Preview'}
        intro={intro ? RichText.render(intro) : undefined}
        path={slug}
        version={version}
      />
      {showStarterKit ? (
        <Typography style={{ display: 'flex', alignItems: 'center' }} margin={{ bottom: 4 }}>
          <Button href="https://confluence.glhec.org/confluence/x/O8EXDg">
            Download the Starter Kit
          </Button>{' '}
          <em className="ml-1">on Confluence</em>
        </Typography>
      ) : (
        ''
      )}
      <div>
        <RichText render={page_content} htmlSerializer={htmlSerializer} />
      </div>
    </PrimaryLayout>
  );
};

export default PageTemplate;

export const query = graphql`
  query PageTemplateQuery($uid: String, $tag: [String!]) {
    prismic {
      allPages(uid: $uid, tags: $tag) {
        edges {
          node {
            title
            intro
            page_content
            _meta {
              uid
              tags
            }
          }
        }
      }
    }
  }
`;
